import request from '@/utils/request'

export function indexData(data) {
  return request({
    url: '/api/v1/index',
    method: 'post',
    data
  })
}

export function pageConfig(data) {
  return request({
    url: '/api/v1/config',
    method: 'post',
    data
  })
}

export function caseList(data) {
  return request({
    url: '/api/v1/caseList',
    method: 'post',
    data
  })
}


export function newsList(data) {
  return request({
    url: '/api/v1/newsList',
    method: 'post',
    data
  })
}

export function feedback(data) {
  return request({
    url: '/api/v1/feedback',
    method: 'post',
    data
  })
}

export function aboutData(data) {
  return request({
    url: '/api/v1/about',
    method: 'post',
    data
  })
}

export function category(data) {
  return request({
    url: '/api/v1/category',
    method: 'post',
    data
  })
}

export function caseDetail(data) {
  return request({
    url: '/api/v1/caseDetail',
    method: 'post',
    data
  })
}

export function newsDetail(data) {
  return request({
    url: '/api/v1/newsDetail',
    method: 'post',
    data
  })
}

export function serviceDetail(data) {
  return request({
    url: '/api/v1/serviceDetail',
    method: 'post',
    data
  })
}

export function showList(data) {
  return request({
    url: '/api/v1/showList',
    method: 'post',
    data
  })
}

export function showDetail(data) {
  return request({
    url: '/api/v1/showDetail',
    method: 'post',
    data
  })
}















// WEBPACK FOOTER //
// ./src/api/web.js